var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.137 274.431C145.137 288.553 133.69 300 119.569 300V300C105.447 300 94 288.553 94 274.431V135.783C94 115.468 110.468 99 130.783 99V99C145.067 99 158.06 107.27 164.107 120.211L198.794 194.442C199.04 194.968 199.567 195.303 200.147 195.303V195.303C200.726 195.303 201.253 194.968 201.499 194.444L236.385 120.027C242.401 107.195 255.294 99 269.465 99V99C289.643 99 306 115.357 306 135.535V274.066C306 288.389 294.389 300 280.066 300V300V300C265.743 300 254.132 288.389 254.132 274.066V186.154C254.132 185.27 253.416 184.554 252.532 184.554V184.554C251.905 184.554 251.336 184.92 251.076 185.491L221.701 249.954C217.783 258.552 209.204 264.07 199.755 264.07V264.07C190.332 264.07 181.773 258.583 177.84 250.02L148.196 185.487C147.935 184.918 147.366 184.554 146.74 184.554V184.554C145.855 184.554 145.137 185.271 145.137 186.156V274.431Z",
    fill: "#AEED0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgL19);
export default __webpack_public_path__ + "static/media/l19.3f9bde377624dbdcc0aef1d85f24838f.svg";
export { ForwardRef as ReactComponent };